import {getRequest, postRequest, deleteRequest} from '../../utils/api'
import store from '../../store'

function getCompanyInfo(callback, failCallback) {
    postRequest("/company/getCompany", {
        
    }).then(res => {
        // store.company.commit("setCompany", res);
        store.commit('company/setCompany', res);
        callback(res);
    }, err => {
        
        failCallback(err);
        // callback(err);
    });
}

function getCompanyInfo1(callback, failCallback) {
    postRequest("/company/getCompanyInfo", {
        
    }).then(res => {
        // store.company.commit("setCompany", res);
        store.commit('company/setCompany', res);
        callback(res);
    }, err => {
        
        failCallback(err);
        // callback(err);
    });
}

function setCompanyInfo(callback, failCallback, form) {
    postRequest("/company/updateCompany", form).then(res => {
        
        callback(res);
    }, err => {
        
        failCallback(err);
        // callback(err);
    });
}

function updateAuth(callback, failCallback, authCode) {
    
    postRequest("/company/updateAuth", {
        authCode: authCode
    }).then(res => {
        callback(res);
    }, err => {
        
        failCallback(err);
        // callback(err);
    });
}

function modifyDevice(callback, failCallback, form) {
    // console.log("addCompany form = " + JSON.stringify(form));
    postRequest("/device/modify", form).then(res => {
        callback(res);
    }, err => {
        
        failCallback(err);
        // callback(err);
    });
}

function removeDevice(callback, failCallback, id) {
    postRequest("/device/delete", {
        id: id
    }).then(res => {
        callback(res);
    }, err => {
        console.log("errrrr");
        failCallback(err);
        // callback(err);
    });
}

export default {
    getCompanyInfo,
    setCompanyInfo,
    updateAuth,
    modifyDevice,
    removeDevice,
    getCompanyInfo1
}


// WEBPACK FOOTER //
// ./src/components/company/CompanyModel.js